import PropTypes from 'prop-types';
import {Component, Suspense} from 'react';
import ConnectionLost from '../../../../sections/DeliveryOptionSection/ConnectionLost/ConnectionLost';
import Track from '../../../utils/tracking';
import GenericFallback from './GenericFallback';
import './GenericFallback.scss';

export default class GenericFallbackSuspense extends Component {
  constructor(props) {
    super(props);
    this.state = {error: false};
  }
  
  componentDidCatch(error) {
    this.setState({error: true});
    Track.track(error);
  }
  
  handleRetryClick() {
    window.location.reload();
  }
  
  render() {
    return (
      <Suspense fallback={this.props.fallback}>
        {this.state.error
          ? <ConnectionLost onClick={this.handleRetryClick} />
          : this.props.children}
      </Suspense>
    );
  }
}

GenericFallbackSuspense.defaultProps = {
  fallback: <GenericFallback />,
};

GenericFallbackSuspense.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node,
};
